"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonGroupInput = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var stitches_config_1 = require("../stitches.config");
var Button_1 = require("./Button");
var ButtonGroup_1 = require("./ButtonGroup");
var StyledButton = (0, stitches_config_1.styled)(Button_1.Button, {
    border: "1px solid",
    variants: {
        outline: {
            brand: {
                borderColor: stitches_config_1.theme.colors.blue7,
            },
            critical: {
                borderColor: stitches_config_1.theme.colors.red7,
            },
            gray: {
                borderColor: stitches_config_1.theme.colors.gray7,
            },
        },
        isFullWidth: {
            true: {
                justifyContent: "center",
            },
        },
    },
});
function ButtonGroupInput(props) {
    return ((0, jsx_runtime_1.jsx)(ButtonGroup_1.ButtonGroup, { children: props.options.map(function (option) {
            return ((0, jsx_runtime_1.jsx)(StyledButton, { isFullWidth: props.fullWidth, fullWidth: props.fullWidth, text: option.text, startIcon: option.startIcon, endIcon: option.endIcon, onClick: function (e) {
                    e.preventDefault();
                    props.onChange(option.value);
                }, color: props.color, outline: props.color, variant: props.value === option.value ? "solid" : "outline" }, option.value));
        }) }));
}
exports.ButtonGroupInput = ButtonGroupInput;
//# sourceMappingURL=ButtonGroupInput.js.map